import React from 'react';
import { ImageAndTiles } from 'types/studio/studio';
import { StudioBaseIconV2 } from 'shared/studio/StudioBaseIcon/StudioBaseIcon';
import styles from './Badges.module.scss';

type Props = {
  badgesOptions: ImageAndTiles['badgesOptions'];
};

const Badges = ({ badgesOptions }: Props) => {
  if (!badgesOptions?.addBadges || !badgesOptions?.badges) {
    return null;
  }

  return (
    <div className={styles.badgesWrap}>
      {badgesOptions?.badges?.map(({ _key, badge }) => (
        <StudioBaseIconV2 key={_key} icon={badge} className={styles.badge} />
      ))}
    </div>
  );
};

export default Badges;
